import React from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useQuery} from "react-query";
import {ALERT_TYPES, ROUTES} from "../../types";
import {useAlert} from "../../components/common/Alert";
import {Loader} from "../../components/common";

const ActivateEmail = () => {
  const { setAlert } = useAlert();
  const { uid, token } = useParams();
  const navigate = useNavigate();

  const {isLoading} = useQuery(["activateEmail", uid, token], {
    onSuccess: () => {
      setAlert('Аккаунт успешно верифицирован!', ALERT_TYPES.SUCCESS);
      navigate(ROUTES.SIGN_IN);
    },
    onError: () => {
      setAlert('Проблемы с верификацией аккаунта!', ALERT_TYPES.ERROR);
      navigate(ROUTES.SIGN_IN);
    }
  });

  if (isLoading) {
    return <Loader />
  }

  return (
    <></>
  )
};

export default ActivateEmail;
